import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const Footer = () => {
  const { t } = useTranslation("components");
  return (
    <div className="footer-saction">
      <div className="container">
        <div className="row">
          <div className="col-md-4">
            <div className="footer-box footer-one">
              <p>
                <img src="../images/Union-icon.png" alt="footer-img" />
                {t("footer.tagline")}
              </p>
            </div>
          </div>
          <div className="col-md-4">
            <div className="footer-box-centar">
              <ul>
                <li>
                  <Link to="/terms-conditions">{t("common:common.termsConditions")}</Link>
                </li>
                <li>
                  <Link to={"/privacy-policy"}>{t("common:common.privacyPolicy")}</Link>
                </li>
              </ul>
            </div>
          </div>
          <div className="col-md-12 col-lg-5">
            <div className="footer-box-right">
             
              <p>{t("footer.copyright")}</p>
               <p><b>{t("common:common.browserNote")}</b></p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Footer;
